import logErrors from '@nykaa/logger/logErrors';
import { isMen } from '@nykaa/seo/utils';
import { variantTransformer } from '@nykaa/wishlist-shared/store/transformer';
import { ApiHelper } from 'shared/api';
import { ROUTES, getUrl } from 'shared/api/urls';
import { queryStringFromParams } from 'shared/helpers/utils/url';
import { ProductSizeData } from 'store/product/types';

interface FetchProductParams {
  id: string;
  store?: string;
  lang?: string;
  priveBand?: string;
}

const mandatoryRequestParams = {
  app_version: '2.0.6',
  source: 'react',
  variants: true,
};

const ERROR_FETCHING_VARIANTS_API = 'Error in Variants API';
export const getVariants = async (params: FetchProductParams) => {
  const url = getUrl(ROUTES.PRODUCT);
  const { lang, id: product_id, priveBand } = params;
  const queryParams = {
    ...mandatoryRequestParams,
    product_id,
    lang,
    ...(priveBand && { customer_tier: isMen() ? 'non_prive' : priveBand }),
  };

  const queryString = queryStringFromParams(queryParams);

  try {
    const {
      data: { response },
    } = await ApiHelper(`${url}${queryString}`, 'get');
    if (!response) {
      return Promise.reject('variants data not found');
    }
    const productSizeData = transformSizeData(response.size_data);
    return {
      variants: variantTransformer(response.options, response.default_pid),
      productSizeData: productSizeData,
    };
  } catch (e) {
    logErrors(e, `${ERROR_FETCHING_VARIANTS_API} :url=${url}`);
    throw e;
  }
};

export const transformSizeData = (sizeData: ProductSizeData) => ({
  enabled: sizeData.enabled,
  buttonText: sizeData.button_text || '',
  unitText: sizeData.unit_text || '',
  units: sizeData.units || [],
  columns: sizeData.columns || [],
});
